export enum Env {
  production = 'production',
  TEST = 'TEST',
  overseas = 'overseas',
}
